export enum Strategy {
  LONG_STOCK = 'LONG_STOCK',
  LONG_CALL = 'LONG_CALL',
  LONG_CALL_SPREAD = 'LONG_CALL_SPREAD',
  SHORT_PUT_SPREAD = 'SHORT_PUT_SPREAD',
  LONG_PUT = 'LONG_PUT',
  LONG_PUT_SPREAD = 'LONG_PUT_SPREAD',
  SHORT_CALL_SPREAD = 'SHORT_CALL_SPREAD',
  IRON_CONDOR = 'SHORT_IRON_CONDOR',
  IRON_BUTTERFLY = 'SHORT_IRON_BUTTERFLY',
  SHORT_STOCK = 'SHORT_STOCK',
  SHORT_CALL = 'SHORT_CALL',
  SHORT_PUT = 'SHORT_PUT',
}
